import { useContext, useEffect, useState } from 'react';
import { distinctUntilChanged, map, tap } from 'rxjs';

import { RxFormContext } from '../Context';

export function useFieldError(field: string): string | undefined {
    const { getErrorStream } = useContext(RxFormContext);

    const [state, setState] = useState(undefined);
    useEffect(() => {
        const sub = getErrorStream()
            .pipe(
                map((s) => s?.[field]),
                distinctUntilChanged(),
                tap(setState),
            )
            .subscribe();
        return () => sub.unsubscribe();
    }, [field, getErrorStream]);
    return state;
}
